// Due dates are CALENDAR DATES, not instants.
//
// "Due the 19th" means the 19th in the shop. The API serves due dates in two
// shapes: jobs.due_date is a timestamp and arrives as "2026-08-19T00:00:00Z",
// while the task-level task_due_date is a DATE column and arrives as
// "2026-08-19". `new Date()` parses BOTH as UTC midnight, and
// toLocaleDateString then renders that in Central — one day EARLIER.
//
// That is how the Job Queue page came to show every date a day early: job
// #8007 read 8/18 for a stored 8/19, and the cards behind it read 10/8, 10/27,
// 11/5 for 10/09, 10/28, 11/06. Same class of bug as the Users → Labor Hours
// panel reading "Hours through 7/29" on 7/30 (fixed 2026-07-30), and the same
// remedy: take the Y/M/D parts and rebuild them as a LOCAL date.
//
// Anything that is not a leading YYYY-MM-DD falls through to the default
// parse, so a genuine timestamp still behaves like a timestamp.

/** Parse a due date as a local calendar date. Returns null for empty/invalid. */
export function parseDueDate(val) {
  if (!val) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(val));
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const parsed = new Date(val);
  return isNaN(parsed.getTime()) ? null : parsed;
}

/** Locale date string for a due date, or '' when there isn't one. */
export function formatDueDate(val) {
  const d = parseDueDate(val);
  return d ? d.toLocaleDateString() : '';
}

/**
 * Late = the due DAY is behind us.
 *
 * Comparing a date-only value against the current instant made a job "late"
 * the moment its due date began — and, before parseDueDate, from 7pm the
 * evening BEFORE it. A job due today is not late.
 */
export function isDueDateLate(val, now = new Date()) {
  const due = parseDueDate(val);
  if (!due) return false;
  const startOfToday = new Date(now);
  startOfToday.setHours(0, 0, 0, 0);
  return due < startOfToday;
}
